import { render, staticRenderFns } from "./EnableSwitch.vue?vue&type=template&id=b71495c2&scoped=true&lang=pug"
import script from "./EnableSwitch.vue?vue&type=script&lang=ts"
export * from "./EnableSwitch.vue?vue&type=script&lang=ts"
import style0 from "./EnableSwitch.vue?vue&type=style&index=0&id=b71495c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71495c2",
  null
  
)

export default component.exports